"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var utils_1 = __importDefault(require("@nexys/utils"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var view_1 = require("../../ui/view");
var utils_2 = require("./utils");
var View = function (dataDef) { return function (props) {
    var data = props.data;
    return (react_1["default"].createElement(react_1["default"].Fragment, null, dataDef.fields
        .filter(function (f) {
        if (typeof f.hideInDetail !== 'undefined' ||
            typeof f.hideInView !== 'undefined') {
            console.warn("Usage of 'hideInDetail' and 'hideInView' are deprecated and won't be supported in the future. Please use 'hide: { detail: true }' or 'hide: { view: true }' instead.");
        }
        return utils_2.shouldShowFieldInView(f);
    })
        .map(function (f, i) {
        var value = utils_1["default"].ds.get(f.name, data);
        var displayValue = f.render ? f.render(data) : value;
        return (react_1["default"].createElement(view_1.Wrapper, { key: i, label: f.label },
            react_1["default"].createElement(Typography_1["default"], null, displayValue)));
    })));
}; };
exports["default"] = View;
